import React, { useState } from "react";
import "./AboutUsPermits.css";

const permits = [
  {
    name: "Mayor's Permit",
    image: "/permits/permit 1.jpg",
    details:
      "This permit certifies that our business is officially registered with the local government for legal operation.",
  },
  {
    name: "DTI Permit",
    image: "/permits/permit 2.jpg",
    details:
      "Issued by the Department of Trade and Industry, this permit ensures our business complies with national regulations.",
  },
  {
    name: "Department of Tourism Accreditation",
    image: "/permits/permit 3.jpg",
    number: "DOT-R4B-TOP-02424-2024",
    details:
      "This accreditation guarantees that our services meet the high standards set by the Department of Tourism.",
  },
];

const AboutUsPermits = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div className="aboutUsPermitContainer">
      <div className="container padAround">
        <div className="about-us-permits">
          {permits.map((permit, index) => (
            <div className="permit-item" key={index}>
              <div
                className="permit-image"
                onClick={() => setSelectedImage(permit.image)}
              >
                <img src={permit.image} alt={permit.name} loading="lazy" />
              </div>
              <h3>{permit.name}</h3>
              <p>{permit.details}</p>
              {permit.number && <p>{permit.number}</p>}
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Popup */}
      {selectedImage && (
        <div className="lightbox" onClick={() => setSelectedImage(null)}>
          <div className="lightbox-content">
            <img src={selectedImage} alt="Permit Preview" loading="lazy" />
          </div>
        </div>
      )}
    </div>
  );
};

export default AboutUsPermits;
